exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div_analyticsNavigationItem:hover{\n    border-bottom: 1px solid #00b4d2 !important;\n}\n\n.div_analyticsNavigationItem:hover a p {\n    color: #00b4d2 !important;\n}\n\n.div_analyticsNavigationItem_last{\n    padding: 0px 30px 0px 30px !important;\n}\n.div_analyticsNavigationItem_first{\n    padding: 0px 30px 0px 30px !important;\n}\n.div_analyticsNavigationItem_selected{\n    border-bottom: 1px solid #00b4d2 !important;\n}\n.div_analyticsNavigationItem_selected a p{\n    color: #00b4d2 !important;\n}", ""]);

// exports
